import React from "react";
import style from "./style.module.scss";
import Row from "./row";
import SkeletonRow from "../../../../../../../components/skeleton-loader/table/row";

const DepositTable = ({ data = [], loading }) => {
  const tableData = Array.isArray(data) ? data : [];
  return (
    <div className={style.batch_table_container}>
      <table className={style.batch_table}>
        <thead>
          <tr className={style.header_row}>
            {/* <th className={style.header_cell}></th> */}
            <th className={`${style.header_cell} ${style.padding_left}`}>
              Routing
            </th>
            <th className={style.header_cell}>Process data</th>
            <th className={style.header_cell}>Account</th>
            <th className={style.header_cell}>Offset</th>
            <th className={style.header_cell}>Trans. Code</th>
            <th className={style.header_cell}>DEBIT/CREDIT</th>
            <th className={style.header_cell}>Dep./ACH date</th>
            <th className={style.header_cell}>Deposit</th>
            <th className={style.header_cell}>Details</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            Array.from({ length: 10 }).map((_, index) => (
              <SkeletonRow
                key={`batch-data-skeleton-row-${index}`}
                columnLength={9}
              />
            ))
          ) : tableData.length === 0 ? (
            <tr>
              <td colSpan="9" className={style.no_data}>
                No data to display
              </td>
            </tr>
          ) : (
            tableData.map((row, index) => <Row data={row} key={index} />)
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DepositTable;
